import { IIssueSummaryResponse } from '@kcftech/prometheustypescriptapiclient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { REFRESH_INTERVAL } from 'configs/constants';
import { sdClient } from 'contexts/SDKClientContext';
import { useLocationFavorites } from 'custom_hooks/data_hooks/favorites/useLocationFavorites';
import { CorporationOverviewFilters } from 'pages/Corporation/types';

async function fetchCorporationIssueMetrics(
    corporationId: string,
    locationIds?: string[]
): Promise<IIssueSummaryResponse> {
    try {
        return await sdClient.getIssueSummaryForCorporation({
            corporationId,
            locationIds,
        });
    } catch (error) {
        throw new Error(
            `Failed to fetch metrics for corporation ${corporationId}: ${
                error instanceof Error ? error.message : 'Unknown error'
            }`
        );
    }
}

export function useCorporationIssueMetrics(
    corporationId: string,
    filters?: CorporationOverviewFilters
) {
    const favorites = useLocationFavorites({ corporationId, locationId: undefined });
    const locationIds =
        filters?.favoritesFilter === 'favorites'
            ? favorites.map((fav) => fav.FavoriteId)
            : undefined;

    return useQuery<IIssueSummaryResponse>({
        queryKey: ['corporationIssueMetrics', corporationId, locationIds],
        queryFn: () => fetchCorporationIssueMetrics(corporationId, locationIds),
        refetchInterval: REFRESH_INTERVAL,
        placeholderData: keepPreviousData,
        staleTime: REFRESH_INTERVAL,
    });
}
